/** Seeded local-dev users for the "View as" picker (dev auth mode only; mirrors apps/api's seed). */
export interface DevUser {
  id: string;
  name: string;
  hint: string;
}

export const DEV_USERS: DevUser[] = [
  { id: 'admin', name: 'Minsu Son', hint: 'Admin · Media · can release · sees restricted photos' },
  { id: 'media', name: 'Daniel Kim', hint: 'Media · can release · sees restricted photos' },
  { id: 'media-upload', name: 'Grace Park', hint: 'Media · no release' },
  { id: 'member', name: 'David Yoon', hint: 'User · released photos only' },
  { id: 'leader', name: 'Hannah Jung', hint: 'User · sees restricted photos' },
  { id: 'joseph', name: 'Joseph Lee', hint: 'User · album access: 1' },
  { id: 'pending', name: 'Rachel Kang', hint: 'Pending access request' },
  { id: 'newcomer', name: 'New visitor', hint: 'Signed in, never requested access' },
];

export const DEFAULT_DEV_USER = DEV_USERS[0]!.id;
